import React from 'react';
import PlayBackground from '../../svgs/components/play_background';
import RotateArrow from '../../svgs/components/rotate_arrow';
import { clickable } from '../../helpers/mouseCursorPosition';
import PropTypes from 'prop-types';
export var ThreeDimensionsRotateArrow = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '60' : _b;
    return (React.createElement(clickable.div, { style: {
            cursor: 'pointer',
        }, className: "play-button" },
        React.createElement("i", { key: "play-triangle", "data-hook": "play-triangle", className: 'gallery-item-video-play-triangle play-triangle ' },
            React.createElement(RotateArrow, { size: size })),
        React.createElement("i", { key: "play-bg", "data-hook": "play-background", className: 'gallery-item-video-play-background play-background ' },
            React.createElement(PlayBackground, { size: size }))));
};
ThreeDimensionsRotateArrow.propTypes = {
    size: PropTypes.string,
};
//# sourceMappingURL=rotateArrow.js.map